import { PhotoType } from "app/models/photoDataPhotoType";

export abstract class Field {
  public title: string;
}

export class SignatureField extends Field {
  public value: SurveyPhoto;
}

export class PlainTextField extends Field {
  public value?: string;
}

export class LocationField extends Field {
  public value?: Coordinate;
}

export class PhotoField extends Field {
  public photos?: SurveyPhoto[];
}

export class CalendarTimeField extends Field {
  public value?: Date;
}

export class SurveyPhoto {
  public blobServiceFileName: string;
  public type: PhotoType;
}

export class Coordinate {
  public latitude: number;
  public longitude: number;
}



// WEBPACK FOOTER //
// /app/SPA/src/app/models/surveyScheme/field.ts